import React, { useState, useEffect, useContext } from "react"
import {
  Row,
  Col,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  Button
} from "reactstrap"
import { useMutation } from "@apollo/react-hooks"
import PropTypes from "prop-types"
import withModal from "components/modal"
import { createMessage as mutation } from "gql/mutations"
import MessageFileUpload from "./MessageFileUpload"
import { TEXT } from "../messageTypes"
import MessageContext from "../MessageContext"

const MessageInput = ({ chatRoomId, disabled, modal }) => {
  const [message, setMessage] = useState("")
  const [createMessage] = useMutation(mutation)
  const { isInitChat } = useContext(MessageContext)

  useInit(isInitChat, setMessage)

  const submitMessage = e => {
    e.preventDefault()

    if (message.replace(/\s/g, "") === "") {
      return
    }

    createMessage({
      variables: {
        input: {
          type: TEXT,
          content: message,
          chatRoom: chatRoomId
        }
      }
    })

    setMessage("")
  }

  return (
    <div className="border-top pt-4">
      <Form onSubmit={e => submitMessage(e)}>
        <Row>
          <Col xs="9">
            <div className="input-field mt-0 mb-0">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button
                    disabled={disabled !== false}
                    outline
                    className="btn"
                    color="success"
                    onClick={() => {
                      const {
                        setHeaderText,
                        setSubmitText,
                        setCentered,
                        setModalContent,
                        toggle
                      } = modal

                      setHeaderText("選擇上傳檔案")
                      setSubmitText("上傳")
                      setCentered(false)
                      setModalContent(
                        <MessageFileUpload
                          modal={modal}
                          chatRoomId={chatRoomId}
                        />
                      )

                      toggle()
                    }}
                  >
                    <i className=" fas fa-upload" />
                  </Button>
                </InputGroupAddon>
                <Input
                  placeholder="輸入訊息"
                  onChange={e =>
                    disabled === false && setMessage(e.target.value)
                  }
                  className="form-control border-0 ml-1"
                  type="text"
                  value={message}
                />
              </InputGroup>
            </div>
          </Col>
          <Col xs="3">
            <Button
              disabled={disabled !== false}
              className="btn btn-circle btn-lg btn-info float-right text-white"
              type="submit"
              value="submit"
            >
              <i className="fas fa-paper-plane" />
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

const useInit = (isInitChat, setMessage) => {
  useEffect(() => {
    if (isInitChat) {
      setMessage("")
    }
  }, [isInitChat, setMessage])
}

MessageInput.propTypes = {
  chatRoomId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  modal: PropTypes.object.isRequired
}

export default withModal(MessageInput)
